<template class="z-index-2000">
    <v-card :loading="loading" :style="`height: auto`">
        <v-card-title ref="title">
            <v-btn small icon @click="closeDialog" color="primary" class="mr-2">
                <v-icon>
                    mdi-close
                </v-icon>
            </v-btn>
            <h3>
                Forecast History
            </h3>
            <v-spacer />
        </v-card-title>
        <v-divider class="ml-4 mr-5" />

        <v-card-text class="mt-6" :style="{ height: `${height - 100}px` }">
            <v-row
                no-gutters
                :style="{ 'background-color': '#eeeeee' }"
                class="mt-8 align-center"
                ref="totals"
            >
                <v-col
                    cols="12"
                    xl="6"
                    lg="6"
                    md="6"
                    class="d-flex justify-center"
                >
                    <p class="my-2 font-weight-black">
                        SCOPE PRICE:
                        {{
                            formatCurrency(
                                project.currency,
                                localHistoryQuote.totalPrice || 0
                            )
                        }}
                    </p>
                </v-col>
                <v-col
                    cols="12"
                    xl="6"
                    lg="6"
                    md="6"
                    class="d-flex justify-center"
                >
                    <p class="my-2 font-weight-black">
                        CURRENT BALANCE TO BILL:
                        {{
                            formatCurrency(
                                project.currency,
                                localHistoryQuote.currentBalanceToBill || 0
                            )
                        }}
                    </p>
                </v-col>
            </v-row>

            <v-col cols="12" class="mb-6">
                <v-data-table
                    :headers="quoteHeaders"
                    :items="historyItems"
                    class="elevation-0 forecast-history-table"
                    :mobile-breakpoint="0"
                    :loading="loading"
                    disable-pagination
                    hide-default-footer
                    :style="{
                        maxWidth: $vuetify.breakpoint.smAndDown
                            ? '100%'
                            : quoteHeaders.length == 2 ||
                              quoteHeaders.length == 3
                            ? '50%'
                            : '100%',
                        width: '100%',
                        margin: '0 auto',
                    }"
                >
                    <template v-slot:top>
                        <v-row
                            no-gutter
                            class="mt-0 mx-0 pt-4 pb-0 pb-4 align-center"
                            :style="{ 'background-color': '#eeeeee' }"
                        >
                            <v-col cols="9"
                                ><h2 class="ml-4">
                                    Scope: {{ localHistoryQuote.name }}
                                </h2>
                            </v-col>

                            <v-spacer />
                        </v-row>
                    </template>
                    <template v-slot:[`item.title`]="{ item }">
                        <v-col
                            :style="{
                                'background-color': '#eee',
                                width: '100%',
                                height: '100%',
                            }"
                            class="ma-0 pa-0 ml-n4"
                        >
                            <p
                                class="mt-4 ml-7 d-flex align-center justify-center"
                                :style="{
                                    'font-size': '12px',
                                    'font-weight': 500,
                                    color: '#5f5f5f',
                                }"
                            >
                                <span class="mt-6 mb-n2">{{ item.title }}</span>
                            </p>
                        </v-col>
                    </template>
                    <!--ITEMS-->
                    <template v-slot:[`item.date`]="{ item, header }">
                        <div v-if="item.title == 'FORECASTED'">
                            <v-col v-if="item[header.month]">
                                <p class="my-1">
                                    {{
                                        Number(
                                            item[header.month].percentage || 0
                                        ).toFixed(1)
                                    }}
                                    %
                                </p>

                                <p class="mb-1">
                                    {{
                                        formatCurrency(
                                            project.currency,
                                            item[header.month].amount || 0
                                        )
                                    }}
                                </p>
                            </v-col>
                            <p v-else>
                                No Forecast Exist
                            </p>
                        </div>

                        <div v-if="item.title == 'INVOICED'">
                            <p class="my-1">
                                {{
                                    formatCurrency(
                                        project.currency,
                                        invoicedThisMonth[header.month]
                                    )
                                }}
                            </p>
                        </div>
                        <div v-if="item.title == 'COMPLIANCE PERCENTAGE'">
                            <p class="my-1">
                                {{
                                    localHistoryQuote[header.month] &&
                                    localHistoryQuote[header.month].amount
                                        ? (
                                              (invoicedThisMonth[header.month] *
                                                  100) /
                                              localHistoryQuote[header.month]
                                                  .amount
                                          ).toFixed(2)
                                        : '-'
                                }}
                                %
                            </p>
                        </div>
                    </template>
                </v-data-table>
            </v-col>
        </v-card-text>
    </v-card>
</template>

<script>
import { mapMutations } from 'vuex'
import moment from 'moment'
import _ from 'lodash'

export default {
    name: 'ForecastHistory',
    props: {
        historyQuote: {
            type: Object,
            required: true,
            default: () => {},
        },
        project: {
            type: Object,
            required: true,
            default: () => {},
        },
        invoices: {
            type: Array,
            required: true,
            default: () => {},
        },
    },
    data() {
        return {
            loading: false,
            forecast: {},
            quoteHeaders: [],
            originalQuoteHeaders: [],
            months: [
                'JAN',
                'FEB',
                'MAR',
                'APR',
                'MAY',
                'JUN',
                'JUL',
                'AUG',
                'SEP',
                'OCT',
                'NOV',
                'DEC',
            ],
            prevBalanceToBill: 0,
            maxAmountValue: 0,
            maxPercentageValue: 0,
            height: 0,
            dateToShow: [],
            forecastedPercentage: 0,
            historyItems: [],
            localHistoryQuote: {},
            invoicedThisMonth: {},
        }
    },

    async mounted() {
        try {
            this.loading = true
            await this.loadData()
        } catch (error) {
            this.setErrorItems({
                source: this.$options.name,
                message: error.message,
            })
        } finally {
            this.loading = false
        }
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        closeDialog() {
            this.$emit('closeDialog')
        },
        async loadData() {
            let previousMonth = moment().format('YYYY-MM')

            this.localHistoryQuote = _.cloneDeep(this.historyQuote)

            if (this.project.forecastV2) {
                Object.values(this.project.forecastV2.scopes).forEach(scope => {
                    if (scope.id == this.localHistoryQuote.id) {
                        if (scope.dates) {
                            Object.values(scope.dates).forEach(date => {
                                if (date.reference) {
                                    this.dateToShow.push(date.reference.date)
                                    this.localHistoryQuote[
                                        date.reference.date
                                    ] = date.reference
                                    this.invoicedThisMonth[
                                        date.reference.date
                                    ] = this.getInvoicedInMonth(
                                        date.reference.date,
                                        this.localHistoryQuote.id
                                    )
                                }
                            })
                        }
                    }
                })
            }

            if (this.dateToShow.length > 0) {
                this.dateToShow = [...new Set(this.dateToShow.sort())]
                const minDate = this.dateToShow[0]
                this.dateToShow = this.monthsBetweenDates(
                    moment(minDate),
                    moment(previousMonth)
                )

                let yearClasses = {}
                let toggleClass = true

                this.originalQuoteHeaders.push({
                    text: '',
                    value: 'title',
                    align: 'center',
                    sortable: false,
                    width: 150,
                })

                this.dateToShow.forEach(date => {
                    const dateParts = date.split('-')
                    const monthIndex = Number(dateParts[1]) - 1
                    const year = dateParts[0]
                    const dateText = `${this.months[monthIndex]}-${year}`

                    if (!yearClasses[year]) {
                        yearClasses[year] = toggleClass
                            ? 'dark-gray-background'
                            : 'gray-background'
                        toggleClass = !toggleClass
                    }
                    this.originalQuoteHeaders.push({
                        text: dateText,
                        value: 'date',
                        align: 'center',
                        sortable: false,
                        width: 150,
                        type: 'month',
                        month: date,
                    })
                })

                this.dateToShow.forEach(date => {
                    const dateParts = date.split('-')
                    const year = dateParts[0]
                    const existent = this.originalQuoteHeaders.find(
                        h => h.text == year
                    )
                    if (!existent) {
                        this.originalQuoteHeaders.push({
                            text: year,
                            value: 'dateYear',
                            align: 'center',
                            sortable: false,
                            width: 100,
                            type: 'year',
                            year,
                        })
                    }
                })

                this.historyItems = [
                    { title: 'FORECASTED', ...this.localHistoryQuote },
                    { title: 'INVOICED', ...this.invoices },
                    { title: 'COMPLIANCE PERCENTAGE', ...{} },
                ]
            }
            this.showMonths()
        },
        formatCurrency(currency, value) {
            return new Intl.NumberFormat('de-DE', {
                style: 'currency',
                currency: currency,
                maximumFractionDigits: 0,
            }).format(value)
        },
        showMonths() {
            this.quoteHeaders = this.originalQuoteHeaders.filter(
                h => h.type != 'year'
            )
            this.viewType = 'month'
        },
        onResize() {
            this.height = window.innerHeight - 150
        },
        monthsBetweenDates(startDate, endDate) {
            let currentDay = startDate
            if (moment(startDate).isAfter(endDate)) {
                currentDay = endDate
            }
            let datesObject = []
            let dates = []
            while (currentDay.isSameOrBefore(endDate)) {
                dates.push(currentDay.format('YYYY-MM'))
                datesObject[currentDay.format('YYYY-MM')] = 0
                currentDay.add(1, 'month')
            }
            return dates
        },
        getInvoicedInMonth(date, scopeId) {
            let totalInvoiced = 0
            if (this.invoices.length > 0) {
                this.invoices.forEach(invoice => {
                    if (invoice.billedOn._seconds) {
                        const invoiceMonth = moment
                            .unix(invoice.billedOn._seconds)
                            .format('YYYY-MM')
                        if (invoiceMonth == date) {
                            if (invoice.items) {
                                Object.values(invoice.items).forEach(
                                    invoiceItems => {
                                        Object.values(invoiceItems).forEach(
                                            item => {
                                                if (item.costId == scopeId) {
                                                    const invoicedInMonth = Number(
                                                        item.currentInvoice || 0
                                                    )
                                                    totalInvoiced += invoicedInMonth
                                                }
                                            }
                                        )
                                    }
                                )
                            }
                        }
                    }
                })
            }
            return totalInvoiced
        },
    },
}
</script>

<style>
.forecast-history-table .v-data-table__wrapper {
    height: 30vh;
    overflow-y: auto;
}
</style>
